<template>
    <b-form :novalidate="true">
      <h5 class="text-primary font-weight-bold pb-2">User Filter</h5>
      <ValidationProvider
        name="user filter"
        rules="regex:^[a-zA-Z0-9@.]*$|min:3|max:100"
        v-slot="{ errors, classes }"
      >
        <b-form-group class="mb-0">
          <label for="filter" class="sr-only">Filter users</label>
          <b-input-group>
            <b-form-input
              id="filter"
              name="filter"
              v-model="content"
              @input="handleInput"
              placeholder="Filter users"
              maxlength="100"
              :class="classes"
              :aria-describedby="$errorsIdString(errors, 'filter')"
            />
          </b-input-group>
          <InputErrors
            :errors="errors"
            errorsIdPrefix="filter"
            class="d-block invalid-feedback"
          />
        </b-form-group>
      </ValidationProvider>
    </b-form>
</template>

<script>
export default {
  name: 'UserFilter',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  watch: {
    value() {
      this.content = this.value;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
};
</script>
